import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'

import { Button } from 'components/patterns'

const DownloadButton = ({ href, children, style, disabled, type }) => {
  if (disabled)
    return (
      <Button style={style} type={type} disabled>
        {children}
      </Button>
    )

  return (
    <a style={style} href={href} download className="download-button">
      <Button type={type}>{children}</Button>
    </a>
  )
}

DownloadButton.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['primary', 'default', 'secondary', 'danger']),
}

DownloadButton.defaultProps = {
  children: strings.downlaod,
}

export default DownloadButton
